var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_7833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8086 0.5C6.18123 0.5 0.808594 5.87264 0.808594 12.5C0.808594 18.1275 4.68315 22.8498 9.90987 24.1467V16.1672H7.43547V12.5H9.90987V10.9198C9.90987 6.83552 11.7584 4.9424 15.7683 4.9424C16.5286 4.9424 17.8404 5.09168 18.3771 5.24048V8.56448C18.0939 8.53472 17.6019 8.51984 16.9908 8.51984C15.0233 8.51984 14.263 9.26528 14.263 11.203V12.5H18.1827L17.5092 16.1672H14.263V24.4122C20.2049 23.6946 24.8091 18.6354 24.8091 12.5C24.8086 5.87264 19.436 0.5 12.8086 0.5Z",
    fill: "#403B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_7833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.808594 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f81bc84669772c2df6f1c6607d43b41b.svg";
export { ForwardRef as ReactComponent };